export default __webpack_public_path__ + "static/media/oir.fbdc9e65.mp3";